import {
  initialState,
  Actions,
  State,
  GET_ALL_DISCOUNTS,
  GET_ALL_DISCOUNTS_SUCCESS,
  GET_ALL_DISCOUNTS_ERROR,
  UPDATE_CURRENT_DISCOUNTS,
} from "../../types/discount/all-discounts";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_DISCOUNTS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_DISCOUNTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_DISCOUNTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_CURRENT_DISCOUNTS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
